import { Container, Service } from 'typedi';

export const DependencyContainer = Container;
export const Injectable = Service;
